/*
* @Author: gujianghua
* @Date:   2020-05-12 11:24:18
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-05-12 19:31:29
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'
const v2 = BASE_API

export default {
	getSignatureUrl: () => {
		return BASE_API + '/cloud/uac/proxy/Common/GetVodUploadSign';
	},
	getList(data) {
		return service({
			url: '/cloud/activity/conference/list',
			method: 'get',
			params: data
		})
	},
	add(data) {
		return service({
			url: '/cloud/activity/conference/add',
			method: 'post',
			data: data
		})
	},
	getAdById(path) {		
		return service({
			url: '/cloud/activity/conference/' + path,
			method: 'get'
		})
	},
	deleteData(path) {
		return service({
			url: '/cloud/activity/conference/delete/' + path,
			method: 'post'
		})
	},
	updateData(data) {
		return service({
			url: '/cloud/activity/conference/update',
			method: 'post',
			data: data
		})		
	},
	getAdList(data) {
		return service({
			url: '/cloud/activity/conference/ad/list',
			method: 'get',
			params: data
		})
	},
	addAd(data) {
		return service({
			url: '/cloud/activity/conference/ad/add',
			method: 'post',
			data: data
		})
	},
	updateAd(data) {
		return service({
			url: '/cloud/activity/conference/ad/update',
			method: 'post',
			data: data
		})
	},
	deleteAd(path) {
		return service({
			url: '/cloud/activity/conference/ad/delete/' + path,
			method: 'post'
		})
	},
	getAdDetailById(path) {		
		return service({
			url: '/cloud/activity/conference/ad/' + path,
			method: 'get'
		})
	},
	getRoomList(data) {
		return service({
			url: '/cloud/activity/conference/room/list',
			method: 'get',
			params: data
		})
	},
	addRoom(data) {
		return service({
			url: '/cloud/activity/conference/room/add',
			method: 'post',
			data: data
		})
	},
	editRoom(data) {
		return service({
			url: '/cloud/activity/conference/room/update',
			method: 'post',
			data: data
		})
	},
	deleteRoom(path) {
		return service({
			url: '/cloud/activity/conference/room/delete/' + path,
			method: 'post'
		})
	},
	getRoomDetailById(path) {
		return service({
			url: '/cloud/activity/conference/room/' + path,
			method: 'get'
		})
	},
}


// WEBPACK FOOTER //
// ./src/api/contentManage/meetingmanage.js